import { MAX_ITEMS_IN_PAGE } from '../../actions/commonActions';

const initState = {
  activities: [],
  activity: {}, 
  activityFilter: '',
  currentPage: 1, 
  totalPages: 0, 
  numItems: 0, 
  min: 1, 
  max: MAX_ITEMS_IN_PAGE 
}

const activitiesReducer = (state = initState, action) => {
  switch (action.type) {
    case 'FETCH_ALL_ACTIVITIES':
      return {
        ...state, 
        activities: action.activities
      }
    case 'ACTIVITY_FILTER':
      return {
        ...state,
        activityFilter: action.activityFilter
      }
    case 'SET_ACTIVITIES_PAGINATION':
      return {
        ...state, 
        numItems: action.numItems, 
        min: action.min, 
        totalPages: action.totalPages,
        currentPage: typeof(action.currentPage) !== "undefined" ? action.currentPage : state.currentPage, 
        max: action.max 
      }
    case 'RESET_ACTIVITIES_PAGINATION':
      return {
        ...state, 
        currentPage: 1, 
        totalPages: 0, 
        numItems: 0, 
        min: 1, 
        max: MAX_ITEMS_IN_PAGE
      }
    case 'CLEAR_ACTIVITIES': 
      return {
        ...state, 
        activities: [] 
      }
    case 'SET_ACTIVITY': 
      return {
        ...state, 
        activity: action.activity 
      }
    case 'RESET_ACTIVITY':
      return {
        ...state, 
        activity: {} 
      }
    case 'SET_ACTIVITY_FIELD_CHANGE':
      return {
        ...state,
        activity: Object.assign(state.activity, action.value) 
      }
    default: 
      return state;
  }
}

export default activitiesReducer